import { useState } from 'react';
import CallToAction from '../../../../../../../shared/CallToAction/CallToAction';
import s from './SearchTerm.module.scss';

export default function SearchTerm({ onFilter }) {
  const [value, setValue] = useState('');

  const handleSearch = () => {
    if (value) {
      onFilter('search', value);
      setValue('');
    }
  };

  return (
    <div className={s.wrapper}>
      <div className={s.title}>Search</div>
      <div className={s.body}>
        <input
          type="search"
          value={value}
          placeholder="Search Term"
          onChange={(event) => {
            setValue(event.target.value);
          }}
          onKeyDown={(event) => {
            if (event.key === 'Enter') {
              handleSearch();
            }
          }}
        />
        <CallToAction onClick={handleSearch}>Search</CallToAction>
      </div>
    </div>
  );
}
